export const WALLBOARD = 'WALLBOARD'

export default {
    WALLBOARD
}
